import { useRef, useEffect } from 'react';

/**
 * Attaches an IntersectionObserver to the returned ref.
 * When the element enters the viewport the "visible" class is added,
 * triggering the CSS reveal transition defined in index.css.
 */
export default function useReveal(threshold = 0.12) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    el.classList.add('reveal');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('visible');
          observer.unobserve(el);
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return ref;
}
